import React from "react";
import styled from "styled-components";
import identity from "../data/uae/identity";
import Attribute from "../components/Attribute";
import Code from "../components/Code";
const Container = styled.div`
  background-color: #fcfcfc;
  max-width: 1152px;
  margin: auto;
  padding: 0 24px 24px 24px;

  h2 {
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 600;
  }
`;

const Identity = () => {
  const today = new Date();
  const dob = new Date(identity.birth_date);
  const age = parseInt(today.getFullYear()) - parseInt(dob.getFullYear());
  const address = identity.address.split(",");

  return (
    <>
      <Container>
        <h2>Identity</h2>
        <Attribute title="Customer Name" value={identity.full_name} />
        <Attribute title="Age" value={age} />
        <Attribute title="Date of Birth" value={identity.birth_date} />
        <Attribute title="Sex" value={identity.gender} />
        <Attribute title="Email" value={identity.email_address} />
        <Attribute title="Phone Number" value={identity.mobile_number} />
        {address.map((line, index) => (
          <Attribute
            key={line}
            title={`Address Line ${index + 1}`}
            value={address[index]}
          />
        ))}
      </Container>
      <Code code={identity} />
    </>
  );
};

export default Identity;
